import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useNavigate } from 'react-router-dom';
import { format, getUnixTime } from "date-fns";
import Select from "react-select";
import { config, encodeBase64RequestBody, randomNumber } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const UserAdd = () => {
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));
  const [ users, setUsers ] = useState(null);
  const [ fullName, setFullName ] = useState('');
  const [ emailAddress, setEmailAddress ] = useState('');
  const [ userDepartment, setUserDepartment ] = useState('Sales');
  const [ userRoleDivision, setUserRoleDivision ] = useState('Staff');
  const [ userPosition, setUserPosition ] = useState('');
  const [ userLevel, setUserLevel ] = useState('User');
  const [ userActive, setUserActive ] = useState('Active');
  const [ approval_1, setApproval_1 ] = useState(null);
  const [ approval_2, setApproval_2 ] = useState(null);
  const [ joinedDate, setJoinedDate ] = useState(format(new Date(), "yyyy-MM-dd"));
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getUsers();
  }, []);
  
  const getUsers = async () => {
    try {
      const requestUsers = {};
      const fetchUsers = await jwtFetch(config.ENDPOINT + 'get/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUsers)
      });
      let responseUsers = await fetchUsers.json();
      if (responseUsers.status === 200) {
        for (let i in responseUsers.data) {
          responseUsers.data[i].value = responseUsers.data[i].user_keyid;
          responseUsers.data[i].label = responseUsers.data[i].full_name;
        }
        setUsers([...responseUsers.data].sort((a, b) => (a.full_name || '').localeCompare(b.full_name || '')));
      } else {
        alert(responseUsers.message);
      }
    } catch (error) {
      console.error('Error in getUsers:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const changeApprovalData = (index, value) => {
    const user = users.find(user => user.user_keyid === value);
    if (index === '1') {
      setApproval_1(user);
    } else if (index === '2') {
      setApproval_2(user);
    }
  }
  
  const submitUserAdd = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const requestUserAdd = {
        "user_keyid": getUnixTime(new Date()) + "" + randomNumber(),
        "created_by": crmUser.user_keyid,
        "created_on": format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        "full_name": fullName,
        "email_address": emailAddress,
        "user_department": userDepartment,
        "user_role_division": userRoleDivision,
        "user_position": userPosition,
        "user_level": userLevel,
        "user_active": userActive,
        "approval_1": approval_1 ? approval_1.user_keyid : null,
        "approval_2": approval_2 ? approval_2.user_keyid : null,
        "joined_date": joinedDate ? joinedDate : null,
      }
      const fetchUserAdd = await jwtFetch(config.ENDPOINT + 'create/user', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestUserAdd)
      });
      const responseUserAdd = await fetchUserAdd.json();
      if (responseUserAdd.status === 200) {
        window.location.href = '/user';
      } else {
        alert(responseUserAdd.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitUserAdd:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="user-add">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="user"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> User Add</div>
                  <form className="row" onSubmit={(e) => submitUserAdd(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required autoFocus/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Email <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="email" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Department <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <select className="form-select" value={userDepartment} onChange={(e) => setUserDepartment(e.target.value)} required>
                            <option value="Sales">Sales</option>
                            <option value="Sales Admin">Sales Admin</option>
                            <option value="Finance">Finance</option>
                            <option value="Marketing">Marketing</option>
                            <option value="Delivery">Delivery</option>
                            <option value="Support">Support</option>
                            <option value="BOD">BOD</option>
                          </select>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Role <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <select className="form-select" value={userRoleDivision} onChange={(e) => setUserRoleDivision(e.target.value)} required>
                            <option value="Staff">Staff</option>
                            <option value="Senior Staff">Senior Staff</option>
                            <option value="Lead">Lead</option>
                            <option value="Manager">Manager</option>
                            <option value="Head">Head</option>
                            <option value="C Level">C Level</option>
                          </select>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Position <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={userPosition} onChange={(e) => setUserPosition(e.target.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Type <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <select className="form-select" value={userLevel} onChange={(e) => setUserLevel(e.target.value)} required>
                            <option value="User">User</option>
                            <option value="Admin">Admin</option>
                          </select>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Join Date</label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="date" value={joinedDate} onChange={(e) => setJoinedDate(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-4">
                        <div className="col-md-4">
                          <label>Status</label>
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch pt-1">
                            <input id="user-active" className="form-check-input" type="checkbox" value="Active" onChange={() => setUserActive(userActive === 'Active' ? 'Inactive' : 'Active')} checked={userActive === 'Active' ? true : false}/>
                            <label htmlFor="user-active" className="form-check-label">{userActive}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card mb-4">
                        <div className="card-body">
                          <div className="fs-18 mb-3">Approval</div>
                          <div className="row form-group align-items-baseline mb-2">
                            <div className="col-md-4">
                              <label>Level 1</label>
                            </div>
                            <div className="col-md-8">
                              <Select value={approval_1} options={users} placeholder="" onChange={(e) => changeApprovalData('1', e.value)} />
                              {approval_1 && (
                                <div className="card my-2">
                                  <div className="card-body">
                                    <p className="mb-0"><i className="bi bi-envelope me-2"/> {approval_1.email_address}</p>
                                    <p className="mb-0"><i className="bi bi-building me-2"/> {approval_1.user_department}</p>
                                    <p className="mb-0"><i className="bi bi-suitcase-lg me-2"/> {approval_1.user_role_division}</p>
                                    <p className="mb-0"><i className="bi bi-person-badge me-2"/> {approval_1.user_position}</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="row form-group align-items-baseline mb-2">
                            <div className="col-md-4">
                              <label>Level 2</label>
                            </div>
                            <div className="col-md-8">
                              <Select value={approval_2} options={users} placeholder="" onChange={(e) => changeApprovalData('2', e.value)} />
                              {approval_2 && (
                                <div className="card my-2">
                                  <div className="card-body">
                                    <p className="mb-0"><i className="bi bi-envelope me-2"/> {approval_2.email_address}</p>
                                    <p className="mb-0"><i className="bi bi-building me-2"/> {approval_2.user_department}</p>
                                    <p className="mb-0"><i className="bi bi-suitcase-lg me-2"/> {approval_2.user_role_division}</p>
                                    <p className="mb-0"><i className="bi bi-person-badge me-2"/> {approval_2.user_position}</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/user'}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                      </div>
                    </div>
                  </form>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAdd;


